import { render } from "./TransactionWrapper.vue?vue&type=template&id=f97d733a&scoped=true"
import script from "./TransactionWrapper.vue?vue&type=script&lang=js"
export * from "./TransactionWrapper.vue?vue&type=script&lang=js"

import "./TransactionWrapper.vue?vue&type=style&index=0&id=f97d733a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97d733a"]])

export default __exports__